// translate.directive.ts
import { isPlatformBrowser } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import {
    Directive,
    ElementRef,
    AfterViewInit,
    signal,
    PLATFORM_ID,
    Inject,
    inject,
    DestroyRef,
    Input,
} from "@angular/core";
// import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
// import { I18nService } from "@app/services/i18n.service";
import { TranslateService } from "@app/services/translate/translate.service";

@Directive({
    selector: "[multilang]",
    providers: [],
    standalone: false,
})
export class TranslateDirective implements AfterViewInit {
    @Input() deeplMode: 'text' | 'html' | 'placeholder' = 'text';
    @Input() defaultlanguage: string = 'de';
    isBrowser = signal<boolean>(false);
    destroyRef = inject(DestroyRef);
    targetLanguage: string = "de";
    // historyNodes: Text[] = [];

    observer: any;
    private translated = [];

    constructor(
        private el: ElementRef,
        @Inject(PLATFORM_ID) protected platformId: any,
        protected translateService: TranslateService,
        // private i18nService: I18nService,
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngAfterViewInit() {
        if (!this.isBrowser()) return;

        if (this.deeplMode === 'placeholder') {
            // no observer for placholder
            this.processTextNodes(this.el.nativeElement);
        } else if (this.deeplMode === 'html') {

            // -------- INNERHTML ----------
            this.processTextNodes(this.el.nativeElement);
            this.observer = new MutationObserver(() => {
                this.processTextNodes(this.el.nativeElement);
            });
            // observer without  characterData: true,
            this.observer.observe(this.el.nativeElement, {
                childList: true,
                subtree: true,
            });
            this.destroyRef.onDestroy(() => this.observer.disconnect());


        } else {
            this.processTextNodes(this.el.nativeElement);

            this.observer = new MutationObserver(() => {
                this.processTextNodes(this.el.nativeElement);
            });

            this.observer.observe(this.el.nativeElement, {
                characterData: true,
                childList: true,
                subtree: true,
            });
            this.destroyRef.onDestroy(() => this.observer.disconnect());
        }

        // this.checkLanguage();
    }

    // checkLanguage() {
    //     this.i18nService.langOb.pipe(
    //         takeUntilDestroyed(this.destroyRef)
    //     ).subscribe(lg => {
    //         this.currentLang = lg;
    //     })
    // }

    processTextNodes(element) {
        const textNodes: Text[] = [];

        if (this.deeplMode === 'placeholder') {
            const plh = this.el.nativeElement.getAttribute('placeholder') || '';
            if (plh?.length > 0 && this.translated !== plh) {
                textNodes.push(this.el.nativeElement);
            }
        } else {
            // Create a TreeWalker to find all visible text nodes
            const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
                acceptNode: (node) => {
                    // Filter out whitespace-only nodes
                    return node.textContent
                        ? NodeFilter.FILTER_ACCEPT
                        : NodeFilter.FILTER_REJECT;
                },
            });

            let currentNode: Text | null;
            // console.log(currentNode?.nodeValue, this.translated, currentNode?.nodeValue === this.translated)
            while ((currentNode = walker.nextNode() as Text | null)) {
                if (this.translated.indexOf(currentNode?.nodeValue) < 0) {
                    textNodes.push(currentNode as Text);
                }
            }
        }


        // Translate each text node individually
        textNodes.forEach((node) => {
            let originalText = '';
            if (node instanceof HTMLInputElement) {
                originalText = node.getAttribute('placeholder') || '';
            } else {
                originalText = node.nodeValue;
            }

            if (originalText?.length > 0) {
                this.translateService.collect(originalText, (translated) => {
                    // console.log(translated)
                    if (translated?.length > 0) {
                        if (node instanceof HTMLInputElement) {
                            node.placeholder = translated;
                        } else {
                            node.textContent = translated;
                        }
                        // this.observer.disconnect();
                        this.translated.push(translated);
                    }
                }, this.defaultlanguage);
            }
        });
    }
}
